import {getUserConfig} from "@utility/utils";

const initialState = {
    list: [],
    loading: false,
    searchParams: {
        page: 1,
        count: 100,
        clubNo: "",
        snsName: "",
        userID: "",
        refresh: false,
        ...getUserConfig("preAccount")
    }
}

const preAccountReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'PRE_ACCOUNT':
            return {
                ...state,
                ...action.payload
            }
        case 'PRE_ACCOUNT_INIT':
            return {
                ...initialState,
                searchParams: {
                    ...initialState.searchParams, ...getUserConfig("preAccount")
                }
            }
        default:
            return {...state};
    }
}

export default preAccountReducer
